window.ocm = window.ocm || {};
ocm = window.ocm || {};
ocm.error_messages = ocm.error_messages || {};

export const error_messages = ocm.error_messages;
